import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { selectUserPermissions } from '../../users/selectors/permission.selectors';
import { setAllowedIntegrationPanels, setAllowedIntegrationPanelsForConversation } from '../actions/work-item-integrations.actions';
import { selectDefaultIntegrationPanels, selectOpenIntegrationPanels } from '../selectors/work-item-integrations.selectors';

@Injectable()
export class GenesysCloudWorkItemIntegrationsEffects {
  readonly setAllowedIntegrationPanels$ = createEffect(() => this.actions$.pipe(
    ofType(setAllowedIntegrationPanels),
    concatLatestFrom(({ conversation }) => [
      this.store.select(selectUserPermissions),
      this.store.select(selectOpenIntegrationPanels(conversation.id)),
      this.store.select(selectDefaultIntegrationPanels)
    ]),
    map(([{ conversation }, userPermissions, openIntegrationPanels, defaultIntegrationPanels]) =>
      setAllowedIntegrationPanelsForConversation({
        conversation,
        integrations: openIntegrationPanels
          || defaultIntegrationPanels.filter(i => !i.permissions || i.permissions.every(p => userPermissions.includes(p)))
      })
    )
  ));

  constructor(private readonly actions$: Actions,
              private readonly store: Store
  ) {}
}
